import React, { useEffect, useMemo, useRef, useState } from "react";


import { createApiClient } from '../lib/apiClient';
import { useUserId } from "../UserIdContext";
import GestorClientes from "./cliente";
import {
  mergeDistinctStrings,
  normalizeStringList,
  pickFirstStringListValue,
  resolveDepositoActual,
} from "./unidadesNegocioApi";



import { FiEdit2, FiPackage, FiRotateCcw, FiTrash2 } from "react-icons/fi";



import "./ingreso.css";



import "./ingresomk.css";



import "./usuarios.css";







const api = createApiClient({



  baseURL: process.env.REACT_APP_API_BASE_URL || "http://localhost:3220",



  headers: { "Content-Type": "application/json" },



});







// Estado del formulario principal



const INITIAL_FORM = {



  cliente: "",



  fecha: "",



  ubicacion: "",



  planta: "",



  unidadNegocio: "",



  nroRemito: "",



  fcGrupoProveedor: "",



  codigo: "",



  detalleProducto: "",



  nroFc: "",



  cantPorFc: "",



  lote: "",



  fechaElaboracion: "",



  fechaVencimiento: "",



  idInterno: "",



  tipoEmbalaje: "",



  pesoMedidas: "",



  nroPallet: "",



  unidadesPorPallet: "",



  recintoSenasa: "",



  ingresoPesa: "no", // "si" / "no"



  observacionesIngreso: "",



  condicion: "OK", // OK / ROTAS



};



// clave del almacenamiento del navegador



const STORAGE_KEY_BASE = "ingreso-mercaderia-borrador";

const UNDO_HISTORY_LIMIT = 12;

const clonePalletSnapshot = (items) => items.map((item) => ({ ...item }));

const formatUndoTimestamp = (value) => {
  if (!value) return "";
  return new Date(value).toLocaleString("es-AR", {
    day: "2-digit",
    month: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  });
};







const toNumber = (v) => {


  const n = Number(v);


  return Number.isFinite(n) ? n : 0;


};





const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

const formatFecha = (value, { autoYear = false, allowStar = false } = {}) => {


  if (!value) return "";


  const raw = String(value).trim();


  if (allowStar && raw.includes("*")) {
    return raw.replace(/[^0-9/*]/g, "").slice(0, 10);
  }


  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) {


    const [year, month, day] = raw.split("-");


    return `${day}/${month}/${year}`;


  }





  const digits = raw.replace(/\D/g, "").slice(0, 8);


  if (!digits) return "";





  const day = digits.slice(0, 2);


  const month = digits.slice(2, 4);


  let year = digits.slice(4, 8);


  const usarYearActual = autoYear && digits.length === 4;





  if (usarYearActual) {


    year = String(new Date().getFullYear());


  }





  let output = day;


  if (digits.length >= 3) output += `/${month}`;


  if (digits.length >= 5 || usarYearActual) output += `/${year}`;


  return output;


};





const toIsoFecha = (value) => {


  if (!value) return "";


  const raw = String(value).trim();


  if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;


  const digits = raw.replace(/\D/g, "");


  if (digits.length < 8) return "";


  const day = digits.slice(0, 2);


  const month = digits.slice(2, 4);


  const year = digits.slice(4, 8);


  return `${year}-${month}-${day}`;


};





const autoSizeStyle = (value, min = 6, max = 32) => {


  const length = clamp(String(value ?? "").length || min, min, max);


  return { width: `calc(${length}ch + 1.6ch)`, maxWidth: "100%" };


};

const COLUMN_RESIZE_MIN_WIDTH = 36;

const resolveClientePlantas = (cliente) =>
  mergeDistinctStrings(
    normalizeStringList(cliente?.plantas),
    normalizeStringList(cliente?.procedencia),
    normalizeStringList(cliente?.planta)
  );

const resolveClientePlanta = (cliente) => resolveClientePlantas(cliente)[0] || "";

const normalizeClienteProductoCode = (value = "") =>
  String(value ?? "")
    .trim()
    .toLowerCase();

const EMPTY_CODIGO_RAPIDO_FORM = {
  codigo: "",
  detalleProducto: "",
};

const normalizeClienteProductCodes = (value) => {
  if (!Array.isArray(value)) return [];

  const seen = new Set();

  return value.reduce((acc, item) => {
    if (!item || typeof item !== "object") return acc;

    const codigo = String(item?.codigo || item?.codProducto || "").trim();
    const detalleProducto = String(
      item?.detalleProducto || item?.detalle || item?.descripcion || ""
    ).trim();

    if (!codigo || !detalleProducto) return acc;

    const key = normalizeClienteProductoCode(codigo);
    if (seen.has(key)) return acc;

    seen.add(key);
    acc.push({ codigo, detalleProducto });
    return acc;
  }, []);
};

const findClienteProductoByCode = (cliente, codigo) => {
  const normalizedCode = normalizeClienteProductoCode(codigo);
  if (!normalizedCode) return null;

  return (
    normalizeClienteProductCodes(cliente?.codigosProducto).find(
      (item) => normalizeClienteProductoCode(item?.codigo) === normalizedCode
    ) || null
  );
};

const resolveDetalleProductoByCodigoChange = ({
  cliente,
  prevCodigo,
  prevDetalleProducto,
  nextCodigo,
}) => {
  const nextMatch = findClienteProductoByCode(cliente, nextCodigo);
  if (nextMatch?.detalleProducto) {
    return nextMatch.detalleProducto;
  }

  const prevMatch = findClienteProductoByCode(cliente, prevCodigo);
  if (
    prevMatch?.detalleProducto &&
    String(prevDetalleProducto || "").trim() === String(prevMatch.detalleProducto || "").trim()
  ) {
    return "";
  }

  return prevDetalleProducto;
};





const PALLET_COLUMNS = [
  { key: "fcGrupoProveedor", fieldKey: "fcGrupoProveedor", label: "FC/ Grupo/ Proveedor", width: 190, minWidth: 140 },
  { key: "codigo", fieldKey: "codigo", label: "C\u00f3digo", width: 140, minWidth: 110 },
  { key: "detalle", fieldKey: "detalleProducto", label: "Detalle del producto", width: 200, minWidth: 160 },
  { key: "cantPorFc", fieldKey: "cantPorFc", label: "Cant. x FC", width: 120, minWidth: 90 },
  { key: "lote", fieldKey: "lote", label: "Nro. lote", width: 120, minWidth: 90 },
  { key: "fechaElaboracion", fieldKey: "fechaElaboracion", label: "F. elaborac.", width: 140, minWidth: 110 },
  { key: "fechaVencimiento", fieldKey: "fechaVencimiento", label: "F. vencim.", width: 140, minWidth: 110 },
  { key: "idInterno", fieldKey: "idInterno", label: "ID", width: 100, minWidth: 80 },
  { key: "tipoEmbalaje", fieldKey: "tipoEmbalaje", label: "Tipo embalaje", width: 160, minWidth: 120 },
  { key: "pesoMedidas", fieldKey: "pesoMedidas", label: "Peso/ medidas", width: 160, minWidth: 120 },
  { key: "nroPallet", fieldKey: "nroPallet", label: "Nro. pallet", width: 160, minWidth: 120 },
  { key: "unidadesPorPallet", fieldKey: "unidadesPorPallet", label: "Unid. x pallet", width: 160, minWidth: 120 },
  { key: "condicion", fieldKey: "condicion", label: "Condici\u00f3n", width: 130, minWidth: 110 },
  { key: "motivoDanio", fieldKey: "motivoDanioIn", label: "Motivo da\u00f1o", width: 180, minWidth: 140 },
  { key: "observaciones", fieldKey: "observacionesIngreso", label: "Observaciones", width: 240, minWidth: 180 },
  { key: "palletOriginal", fieldKey: "palletOriginal", label: "Pallet Original", width: 160, minWidth: 120 },
  { key: "dupPallet", fieldKey: "duplicarPallet", label: "Dup. pallet", width: 130, minWidth: 100 },
  { key: "cuentaPos", fieldKey: "cuentaPosicion", label: "Cuenta pos.", width: 130, minWidth: 100 },
  { key: "delete", label: "", width: 60, minWidth: 50 },
];





const RESUMEN_COLUMNS = [


  { key: "lote", label: "Lote", width: 180, minWidth: 120 },


  { key: "cantidad", label: "Cantidad pallets", width: 180, minWidth: 120 },


  { key: "total", label: "Total unidades", width: 180, minWidth: 120 },


  { key: "acciones", label: "Acciones", width: 140, minWidth: 100 },


];

const FORM_ENTER_FOCUSABLE_SELECTOR = [
  "input:not([type='hidden']):not([disabled]):not([tabindex='-1'])",
  "select:not([disabled]):not([tabindex='-1'])",
  "textarea:not([disabled]):not([tabindex='-1'])",
  "button:not([disabled]):not([tabindex='-1'])",
].join(", ");

const PALLET_CELL_FOCUSABLE_SELECTOR = [
  "input:not([type='hidden']):not([disabled])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
].join(", ");

const AUTO_FILL_STAR_FIELDS = new Set([
  "nroRemito",
  "fcGrupoProveedor",
  "codigo",
  "detalleProducto",
  "cantPorFc",
  "lote",
  "fechaElaboracion",
  "fechaVencimiento",
  "idInterno",
  "tipoEmbalaje",
  "pesoMedidas",
  "nroPallet",
  "recintoSenasa",
  "observacionesIngreso",
]);






const Ingreso = () => {
  const { deposito } = useUserId();
  const depositoActual = resolveDepositoActual(deposito);
  const storageKey = `${STORAGE_KEY_BASE}-${depositoActual}`;



  const [form, setForm] = useState(INITIAL_FORM);



  const [mantenerDatos, setMantenerDatos] = useState(true);



  const [replicarPor, setReplicarPor] = useState();



  const [pallets, setPallets] = useState([]);



  const [mostrarModal, setMostrarModal] = useState(false);



  const [dupModalOpen, setDupModalOpen] = useState(false);



  const [dupModalIndex, setDupModalIndex] = useState(null);



  const [tieneCambios, setTieneCambios] = useState(false);



  const [clienteQuery, setClienteQuery] = useState("");



  const [clientes, setClientes] = useState([]);



  const [clienteSel, setClienteSel] = useState(null);
  const [clienteEditar, setClienteEditar] = useState(null);



  const [buscandoCliente, setBuscandoCliente] = useState(false);



  const [guardando, setGuardando] = useState(false);
  const [modalError, setModalError] = useState("");
  const [ocupacionesConfig, setOcupacionesConfig] = useState([]);
  const [codigoRapidoOpen, setCodigoRapidoOpen] = useState(false);
  const [codigoRapidoSaving, setCodigoRapidoSaving] = useState(false);
  const [codigoRapidoError, setCodigoRapidoError] = useState("");
  const [codigoRapidoForm, setCodigoRapidoForm] = useState(EMPTY_CODIGO_RAPIDO_FORM);


  const [mensaje, setMensaje] = useState(null);


  const [clienteIndex, setClienteIndex] = useState(-1);

  const [clienteListOpen, setClienteListOpen] = useState(false);

  const [codigoListOpen, setCodigoListOpen] = useState(false);

  const [codigoIndex, setCodigoIndex] = useState(-1);


  const tableScrollRef = useRef(null);


  const tableTopScrollRef = useRef(null);


  const [tableScrollW, setTableScrollW] = useState(0);


  const [tableClientW, setTableClientW] = useState(0);


  const clienteBlurTimerRef = useRef(null);
  const codigoBlurTimerRef = useRef(null);
  const codigoInputRef = useRef(null);
  const detalleProductoInputRef = useRef(null);
  const codigoRapidoCodigoInputRef = useRef(null);
  const codigoRapidoDetalleInputRef = useRef(null);


  const [palletColWidths, setPalletColWidths] = useState(() =>


    PALLET_COLUMNS.map((col) => col.width)


  );


  const [resumenColWidths, setResumenColWidths] = useState(() =>


    RESUMEN_COLUMNS.map((col) => col.width)


  );


  const [selectedPalletColumn, setSelectedPalletColumn] = useState(null);

  const [undoHistory, setUndoHistory] = useState([]);

  const [undoModalOpen, setUndoModalOpen] = useState(false);

  const undoSequenceRef = useRef(0);

  const clienteCodigosProducto = useMemo(
    () => normalizeClienteProductCodes(clienteSel?.codigosProducto),
    [clienteSel]
  );

  const codigoClienteMatch = useMemo(
    () => findClienteProductoByCode(clienteSel, form.codigo),
    [clienteSel, form.codigo]
  );

  const codigosProductoFiltrados = useMemo(() => {
    const query = normalizeClienteProductoCode(form.codigo);
    if (!query) return clienteCodigosProducto;

    return clienteCodigosProducto.filter((item) =>
      normalizeClienteProductoCode(
        `${item?.codigo || ""} ${item?.detalleProducto || ""}`
      ).includes(query)
    );
  }, [clienteCodigosProducto, form.codigo]);

  const closeCodigoRapidoModal = () => {
    setCodigoRapidoOpen(false);
    setCodigoRapidoSaving(false);
    setCodigoRapidoError("");
    setCodigoRapidoForm(EMPTY_CODIGO_RAPIDO_FORM);
  };

  const openCodigoRapidoModal = (initialValue = {}) => {
    setCodigoRapidoForm({
      codigo: String(initialValue?.codigo || form.codigo || "").trim(),
      detalleProducto: String(
        initialValue?.detalleProducto || form.detalleProducto || ""
      ),
    });
    setCodigoRapidoError("");
    setCodigoRapidoOpen(true);
  };

  const saveCodigoRapido = async () => {
    const clienteNombre = String(clienteSel?.nombreCliente || "").trim();
    const codigo = String(codigoRapidoForm?.codigo || "").trim();
    const detalleProducto = String(codigoRapidoForm?.detalleProducto || "").trim();

    if (!clienteNombre) {
      setCodigoRapidoError("Selecciona un cliente antes de agregar un codigo.");
      return;
    }

    if (!codigo || !detalleProducto) {
      setCodigoRapidoError("Completa codigo y detalle para guardarlo.");
      return;
    }

    const codigoKey = normalizeClienteProductoCode(codigo);
    const duplicatedCode = clienteCodigosProducto.some(
      (item) => normalizeClienteProductoCode(item?.codigo) === codigoKey
    );

    if (duplicatedCode) {
      setCodigoRapidoError(`El codigo ${codigo} ya existe en este cliente.`);
      return;
    }

    const nextCodigos = [...clienteCodigosProducto, { codigo, detalleProducto }];

    try {
      setCodigoRapidoSaving(true);
      setCodigoRapidoError("");

      const { data } = await api.put(
        `/api/clientes/editar/${encodeURIComponent(clienteNombre)}`,
        { codigosProducto: nextCodigos }
      );

      const nextCliente =
        data && typeof data === "object"
          ? data
          : { ...clienteSel, codigosProducto: nextCodigos };

      setClienteSel(nextCliente);
      setForm((prev) => ({
        ...prev,
        codigo,
        detalleProducto,
      }));

      closeCodigoRapidoModal();
      setFeedback("Código de producto guardado en el cliente.", "ok");

      window.requestAnimationFrame(() => {
        detalleProductoInputRef.current?.focus();
      });
    } catch (error) {
      console.error("PUT /api/clientes/editar/:nombreCliente", error?.response || error);
      setCodigoRapidoError(
        error?.response?.data?.error || "No se pudo guardar el codigo para este cliente."
      );
      setCodigoRapidoSaving(false);
    }
  };

  const handleCodigoRapidoModalKeyDown = (e) => {
    if (e.key !== "Enter") return;
    if (e.defaultPrevented || e.isComposing || e.ctrlKey || e.altKey || e.metaKey) return;

    const target = e.target;
    if (!(target instanceof HTMLElement)) return;

    const tagName = target.tagName;
    if (tagName === "TEXTAREA" || tagName === "BUTTON" || tagName === "A") return;

    e.preventDefault();

    const detalleProducto = String(codigoRapidoForm?.detalleProducto || "").trim();
    if (target === codigoRapidoCodigoInputRef.current && !detalleProducto) {
      codigoRapidoDetalleInputRef.current?.focus();
      return;
    }

    if (!codigoRapidoSaving) {
      saveCodigoRapido();
    }
  };

  const handleCodigoFieldKeyDown = (e) => {
    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return;
    }

    if (e.key === "ArrowDown") {
      e.preventDefault();
      e.stopPropagation();
      setCodigoListOpen(true);
      setCodigoIndex((prev) =>
        Math.min(prev + 1, codigosProductoFiltrados.length - 1)
      );
      return;
    }

    if (e.key === "ArrowUp") {
      e.preventDefault();
      e.stopPropagation();
      setCodigoListOpen(true);
      setCodigoIndex((prev) => Math.max(prev - 1, 0));
      return;
    }

    if (e.key === "Escape") {
      setCodigoListOpen(false);
      setCodigoIndex(-1);
      return;
    }

    if (e.key !== "Enter") return;

    if (codigoListOpen && codigosProductoFiltrados.length > 0) {
      const pickIndex = codigoIndex >= 0 ? codigoIndex : 0;
      const item = codigosProductoFiltrados[pickIndex];
      if (item) {
        e.preventDefault();
        e.stopPropagation();
        handleSelectCodigoProducto(item);
      }
      return;
    }

    const codigo = String(form.codigo || "").trim();
    if (!codigo || !clienteSel?.nombreCliente || codigoClienteMatch) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    openCodigoRapidoModal({ codigo, detalleProducto: form.detalleProducto });
  };

  const handleSelectCodigoProducto = (item) => {
    if (!item) return;

    if (codigoBlurTimerRef.current) {
      clearTimeout(codigoBlurTimerRef.current);
      codigoBlurTimerRef.current = null;
    }

    setForm((prev) => ({
      ...prev,
      codigo: String(item.codigo || ""),
      detalleProducto: String(item.detalleProducto || ""),
    }));
    setCodigoListOpen(false);
    setCodigoIndex(-1);

    window.requestAnimationFrame(() => detalleProductoInputRef.current?.focus());
  };

  const handleCodigoFocus = () => {
    if (codigoBlurTimerRef.current) {
      clearTimeout(codigoBlurTimerRef.current);
      codigoBlurTimerRef.current = null;
    }
    if (clienteSel) setCodigoListOpen(true);
  };

  const handleCodigoBlur = () => {
    if (codigoBlurTimerRef.current) clearTimeout(codigoBlurTimerRef.current);
    codigoBlurTimerRef.current = setTimeout(() => {
      setCodigoListOpen(false);
      setCodigoIndex(-1);
      codigoBlurTimerRef.current = null;
    }, 120);
  };

  useEffect(() => {
    if (!codigoRapidoOpen) return undefined;

    const rafId = window.requestAnimationFrame(() => {
      codigoRapidoCodigoInputRef.current?.focus();
      codigoRapidoCodigoInputRef.current?.select?.();
    });

    return () => window.cancelAnimationFrame(rafId);
  }, [codigoRapidoOpen]);

  const pushUndoHistory = (label, snapshot) => {
    if (!label || !Array.isArray(snapshot)) return;

    undoSequenceRef.current += 1;

    const nextEntry = {
      id: `undo-${Date.now()}-${undoSequenceRef.current}`,
      label,
      createdAt: Date.now(),
      snapshot: clonePalletSnapshot(snapshot),
    };

    setUndoHistory((prev) => [nextEntry, ...prev].slice(0, UNDO_HISTORY_LIMIT));
  };

  const handleRecuperarPaso = (stepId) => {
    const stepIndex = undoHistory.findIndex((step) => step.id === stepId);
    if (stepIndex === -1) return;

    const step = undoHistory[stepIndex];
    setPallets(clonePalletSnapshot(step.snapshot));
    setUndoHistory((prev) => prev.slice(stepIndex + 1));
    setUndoModalOpen(false);
    setFeedback(`Se recupero el paso: ${step.label}`, "ok");
  };

  const handleDeshacerUltimoPaso = () => {
    if (!undoHistory[0]) return;
    handleRecuperarPaso(undoHistory[0].id);
  };






  //Al montar el componente: restaurar si hay borrador



  useEffect(() => {



    const saved = localStorage.getItem(storageKey);



    if (!saved) return;



    try {


      const data = JSON.parse(saved);


      if (data.form) {


        const nextForm = { ...INITIAL_FORM, ...data.form };


        setForm({


          ...nextForm,


          fecha: formatFecha(nextForm.fecha, { autoYear: true }),


          fechaElaboracion: formatFecha(nextForm.fechaElaboracion, { allowStar: true }),


          fechaVencimiento: formatFecha(nextForm.fechaVencimiento, { allowStar: true }),


        });


      }


      if (Array.isArray(data.pallets)) {


        setPallets(


          data.pallets.map((p) => ({


            ...p,


            fecha: formatFecha(p.fecha, { autoYear: true }),


            fechaElaboracion: formatFecha(p.fechaElaboracion, { allowStar: true }),


            fechaVencimiento: formatFecha(p.fechaVencimiento, { allowStar: true }),


          }))


        );


      }


      if (data.clienteSel) setClienteSel(data.clienteSel);


      if (data.clienteQuery) setClienteQuery(data.clienteQuery);


      if (data.form || data.pallets || data.clienteSel) setTieneCambios(true);


    } catch (err) {


      console.error("Error leyendo borrador de ingreso:", err);



    }



  }, [storageKey]);







  //Cada vez que cambien form o pallets: guardar borrador



  useEffect(() => {



    const sinPallets = pallets.length === 0;



    const formEsInicial = JSON.stringify(form) === JSON.stringify(INITIAL_FORM);



    const sinCliente = !clienteSel && !clienteQuery;







    if (sinPallets && formEsInicial && sinCliente) {



      localStorage.removeItem(storageKey);



      setTieneCambios(false);



      return;



    }







    const data = { form, pallets, clienteSel, clienteQuery };



    localStorage.setItem(storageKey, JSON.stringify(data));



    setTieneCambios(true);



  }, [form, pallets, clienteSel, clienteQuery, storageKey]);







  // permite bajar y subir con las flechas del teclado



  useEffect(() => {


    const handleKeyDown = (e) => {


      const key = e.key;


      const code = e.code;



      const keyCode = e.keyCode;







      const isArrowDown =



        key === "ArrowDown" || code === "ArrowDown" || keyCode === 40;



      const isArrowUp =



        key === "ArrowUp" || code === "ArrowUp" || keyCode === 38;







      if (!isArrowDown && !isArrowUp) return;







      const tag = e.target.tagName;


      if (


        ["SELECT", "INPUT", "TEXTAREA"].includes(tag) ||


        e.target.isContentEditable


      )


        return;






      // Verificación opcional



      // console.log("KEYDOWN flecha OK", e.key, e.target.tagName);







      e.preventDefault();







      const step = 60;



      const direction = isArrowDown ? 1 : -1;







      window.scrollBy({



        top: step * direction,



        left: 0,



        behavior: "smooth",



      });



    };







    window.addEventListener("keydown", handleKeyDown);


    return () => window.removeEventListener("keydown", handleKeyDown);


  }, []);





  useEffect(() => {


    const topEl = tableTopScrollRef.current;


    const tableEl = tableScrollRef.current;


    if (!topEl || !tableEl) {


      setTableScrollW(0);


      setTableClientW(0);


      return;


    }





    const syncFromTop = () => {


      if (tableEl.scrollLeft !== topEl.scrollLeft) {


        tableEl.scrollLeft = topEl.scrollLeft;


      }


    };


    const syncFromTable = () => {


      if (topEl.scrollLeft !== tableEl.scrollLeft) {


        topEl.scrollLeft = tableEl.scrollLeft;


      }


    };


    const measure = () => {


      setTableScrollW(tableEl.scrollWidth || 0);


      setTableClientW(tableEl.clientWidth || 0);


    };





    topEl.addEventListener("scroll", syncFromTop);


    tableEl.addEventListener("scroll", syncFromTable);


    window.addEventListener("resize", measure);


    measure();





    return () => {


      topEl.removeEventListener("scroll", syncFromTop);


      tableEl.removeEventListener("scroll", syncFromTable);


      window.removeEventListener("resize", measure);


    };


  }, [pallets, palletColWidths]);






  // Maneja cambios en el formulario principal



  const handleFormChange = (e) => {


    const { name, value } = e.target;


    const nextValue =


      name === "fecha"


        ? formatFecha(value, { autoYear: true })


        : name === "fechaElaboracion" || name === "fechaVencimiento"


        ? formatFecha(value, { allowStar: true })


        : value;


    setForm((prev) => {
      if (name === "codigo") {
        return {
          ...prev,
          codigo: nextValue,
          detalleProducto: resolveDetalleProductoByCodigoChange({
            cliente: clienteSel,
            prevCodigo: prev.codigo,
            prevDetalleProducto: prev.detalleProducto,
            nextCodigo: nextValue,
          }),
        };
      }

      return {
        ...prev,
        [name]: nextValue,
      };
    });


  };






  // Maneja el checkbox de "mantener datos"



  const handleMantenerDatosChange = (e) => {



    setMantenerDatos(e.target.checked);



  };







  // Maneja el input "replicar ingreso por"



  const handleReplicarChange = (e) => {



    const value = parseInt(e.target.value, 10);



    setReplicarPor(Number.isFinite(value) ? value : undefined);



  };







  const handleLimpiarFormulario = () => {



    setForm(INITIAL_FORM);



    setPallets([]);



    setClienteSel(null);



    setClienteQuery("");



    setClientes([]);



    setReplicarPor(undefined);



    setMantenerDatos(true);



    setBuscandoCliente(false);



    setMostrarModal(false);



    setDupModalOpen(false);


    setDupModalIndex(null);


    setTieneCambios(false);


    setMensaje(null);


    setClienteIndex(-1);

    setClienteListOpen(false);

    setCodigoListOpen(false);

    setCodigoIndex(-1);


    setUndoHistory([]);


    setUndoModalOpen(false);


    localStorage.removeItem(storageKey);


  };






  const handleSelectCliente = (cliente) => {


    if (clienteBlurTimerRef.current) {


      clearTimeout(clienteBlurTimerRef.current);


      clienteBlurTimerRef.current = null;


    }


    setClienteSel(cliente);
    setModalError("");


    setClienteQuery(cliente?.nombreCliente || "");


    setForm((prev) => ({


      ...prev,


      // usar los valores guardados en el cliente (no los anteriores del form)



      ubicacion: pickFirstStringListValue(cliente?.ubicacion),



      planta: resolveClientePlanta(cliente),



      unidadNegocio: pickFirstStringListValue(cliente?.unidadNegocio),

      detalleProducto: resolveDetalleProductoByCodigoChange({
        cliente,
        prevCodigo: prev.codigo,
        prevDetalleProducto: prev.detalleProducto,
        nextCodigo: prev.codigo,
      }),


    }));


    setClientes([]);


    setClienteIndex(-1);

    setClienteListOpen(false);

    setCodigoListOpen(false);

    setCodigoIndex(-1);


  };





  const handleClienteEditado = (clienteGuardado) => {
    if (!clienteGuardado?._id || String(clienteGuardado._id) !== String(clienteEditar?._id)) return;

    const clienteAnterior = clienteEditar;
    setClienteSel(clienteGuardado);
    setClienteQuery(clienteGuardado.nombreCliente || "");
    setClientes((prev) => prev.map((cliente) =>
      String(cliente._id) === String(clienteGuardado._id) ? clienteGuardado : cliente
    ));
    setForm((prev) => {
      const detalleAnterior = findClienteProductoByCode(clienteAnterior, prev.codigo)?.detalleProducto;
      const detalleNuevo = findClienteProductoByCode(clienteGuardado, prev.codigo)?.detalleProducto;
      return {
        ...prev,
        cliente: clienteGuardado.nombreCliente || prev.cliente,
        ubicacion: prev.ubicacion === pickFirstStringListValue(clienteAnterior?.ubicacion)
          ? pickFirstStringListValue(clienteGuardado.ubicacion)
          : prev.ubicacion,
        planta: prev.planta === resolveClientePlanta(clienteAnterior)
          ? resolveClientePlanta(clienteGuardado)
          : prev.planta,
        unidadNegocio: prev.unidadNegocio === pickFirstStringListValue(clienteAnterior?.unidadNegocio) ||
          !normalizeStringList(clienteGuardado.unidadNegocio).includes(prev.unidadNegocio)
          ? pickFirstStringListValue(clienteGuardado.unidadNegocio)
          : prev.unidadNegocio,
        detalleProducto: !prev.detalleProducto || prev.detalleProducto === detalleAnterior
          ? detalleNuevo || ""
          : prev.detalleProducto,
      };
    });
    setFeedback("Cliente actualizado correctamente", "ok");
  };

  const handleClienteKeyDown = (e) => {


    if (!clientes.length) return;





    if (e.key === "ArrowDown") {


      e.preventDefault();


      setClienteIndex((prev) => Math.min(prev + 1, clientes.length - 1));


      return;


    }





    if (e.key === "ArrowUp") {


      e.preventDefault();


      setClienteIndex((prev) => Math.max(prev - 1, 0));


      return;


    }





    if (e.key === "Enter") {


      const pickIndex = clienteIndex >= 0 ? clienteIndex : 0;


      if (clientes[pickIndex]) {


        e.preventDefault();


        handleSelectCliente(clientes[pickIndex]);


      }


      return;


    }





    if (e.key === "Tab") {


      const pickIndex =


        clienteIndex >= 0 ? clienteIndex : clientes.length === 1 ? 0 : -1;


      if (clientes[pickIndex]) {


        handleSelectCliente(clientes[pickIndex]);


      }


      return;


    }





    if (e.key === "Escape") {


      setClientes([]);


      setClienteIndex(-1);

      setClienteListOpen(false);


    }


  };





  const handleClienteBlur = () => {


    if (clienteBlurTimerRef.current) {


      clearTimeout(clienteBlurTimerRef.current);


    }


    clienteBlurTimerRef.current = setTimeout(() => {


      setClientes([]);


      setClienteIndex(-1);

      setClienteListOpen(false);


      clienteBlurTimerRef.current = null;


    }, 120);


  };





  const handleClienteFocus = () => {


    if (clienteBlurTimerRef.current) {


      clearTimeout(clienteBlurTimerRef.current);


      clienteBlurTimerRef.current = null;


    }

    setClienteListOpen(true);


  };

  const handleFormEnterNavigation = (e) => {
    if (e.key !== "Enter" || e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return;
    }

    const target = e.target;
    if (!(target instanceof HTMLElement)) return;

    const tagName = target.tagName.toLowerCase();
    const targetType = (target.getAttribute("type") || "").toLowerCase();

    if (tagName === "textarea") return;
    if (tagName === "button" || targetType === "submit") return;

    e.preventDefault();

    if (
      target instanceof HTMLInputElement &&
      AUTO_FILL_STAR_FIELDS.has(target.name) &&
      !String(target.value || "").trim()
    ) {
      setForm((prev) => ({
        ...prev,
        [target.name]: "*",
      }));
    }

    const formEl = e.currentTarget;
    if (!(formEl instanceof HTMLFormElement)) return;

    const focusables = Array.from(
      formEl.querySelectorAll(FORM_ENTER_FOCUSABLE_SELECTOR)
    ).filter((el) => {
      if (!(el instanceof HTMLElement)) return false;
      const style = window.getComputedStyle(el);
      return style.visibility !== "hidden" && style.display !== "none";
    });

    if (!focusables.length) return;

    const currentIndex = focusables.indexOf(target);
    const nextEl = currentIndex >= 0 ? focusables[currentIndex + 1] : focusables[0];

    if (nextEl) {
      const nextTag = nextEl.tagName.toLowerCase();
      const nextType = (nextEl.getAttribute("type") || "").toLowerCase();
      if (nextTag === "button" || nextType === "submit") {
        if (nextEl instanceof HTMLButtonElement) {
          nextEl.click();
          return;
        }
      }

      if (nextEl instanceof HTMLElement) {
        nextEl.focus();
      }
      return;
    }

    if (typeof formEl.requestSubmit === "function") {
      formEl.requestSubmit();
    } else {
      formEl.dispatchEvent(new Event("submit", { bubbles: true, cancelable: true }));
    }
  };





  const startResizeColumn = (tableKey, index) => (event) => {


    event.preventDefault();


    event.stopPropagation();


    const startX = event.clientX;


    const isPallet = tableKey === "pallet";


    const widths = isPallet ? palletColWidths : resumenColWidths;


    const columns = isPallet ? PALLET_COLUMNS : RESUMEN_COLUMNS;


    const minWidth = columns[index]?.resizeMinWidth ?? COLUMN_RESIZE_MIN_WIDTH;


    const startWidth =


      widths[index] ||


      event.currentTarget.parentElement.getBoundingClientRect().width;


    const setWidths = isPallet ? setPalletColWidths : setResumenColWidths;





    const handleMouseMove = (moveEvent) => {


      const nextWidth = Math.max(minWidth, startWidth + moveEvent.clientX - startX);


      setWidths((prev) => {


        const next = [...prev];


        next[index] = nextWidth;


        return next;


      });


    };





    const handleMouseUp = () => {


      document.removeEventListener("mousemove", handleMouseMove);


      document.removeEventListener("mouseup", handleMouseUp);


      document.body.style.cursor = "";


      document.body.style.userSelect = "";


    };





    document.addEventListener("mousemove", handleMouseMove);


    document.addEventListener("mouseup", handleMouseUp);


    document.body.style.cursor = "col-resize";


    document.body.style.userSelect = "none";


  };






  // Agregar pallets al listado (botón "Continuar")



  const handleAgregarPallets = (e) => {



    if (e?.preventDefault) e.preventDefault();

    if (!clienteSel?._id) {
      setFeedback(
        "Seleccione un cliente valido de la lista antes de agregar pallets",
        "warn"
      );
      return;
    }







    const parsedReplicar = parseInt(replicarPor, 10);



    const cantidad =



      Number.isFinite(parsedReplicar) && parsedReplicar > 0 ? parsedReplicar : 1;







    // Intento de numerar los pallets si nroPallet es numerico



    let basePalletNumber = parseInt(form.nroPallet, 10);



    const esBaseNumerica = Number.isFinite(basePalletNumber);







    const nuevosPallets = Array.from({ length: cantidad }, (_, index) => {



      const nroPalletCalculado = esBaseNumerica



        ? String(basePalletNumber + index)



        : form.nroPallet;







      return {



        cliente: form.cliente,



        fecha: form.fecha,



        ubicacion: form.ubicacion,



        planta: form.planta,



        unidadNegocio: form.unidadNegocio,



        nroRemito: form.nroRemito,







        fcGrupoProveedor: form.fcGrupoProveedor,



        codigo: form.codigo,



        detalleProducto:
          findClienteProductoByCode(clienteSel, form.codigo)?.detalleProducto ||
          form.detalleProducto,



        nroFc: form.nroFc,



        cantPorFc: form.cantPorFc,



        lote: form.lote,



        fechaElaboracion: form.fechaElaboracion,



        fechaVencimiento: form.fechaVencimiento,



        idInterno: form.idInterno,



        tipoEmbalaje: form.tipoEmbalaje,



        pesoMedidas: form.pesoMedidas,



        nroPallet: nroPalletCalculado,



        unidadesPorPallet: form.unidadesPorPallet,



        recintoSenasa: form.recintoSenasa,



        ingresoPesa: form.ingresoPesa,



        observacionesIngreso: form.observacionesIngreso,

        condicion: form.condicion,







        motivoDanioIn: "",



        duplicarPallet: false,



        cuentaPosicion: true,



        esDuplicado: false,



        palletOriginal: "",



      };



    });







    setPallets((prev) => [...prev, ...nuevosPallets]);







    if (!mantenerDatos) {



      setForm(INITIAL_FORM);



      setReplicarPor(1);



    }



  };







  // Maneja cambios en cada celda de la tabla de pallets



  const handlePalletChange = (index, field, value) => {



    const parseNumero = (v) => {



      const n = parseFloat(v);



      return isNaN(n) ? 0 : n; // "*" o vacío -> 0



    };







    const nextValue =


      field === "fechaElaboracion" || field === "fechaVencimiento"


        ? formatFecha(value, { allowStar: true })


        : value;





    setPallets((prev) => {


      const palletsCopy = [...prev];



      const palletActual = palletsCopy[index];







      // ðŸ”¹ Caso especial: cambio de unidades en un duplicado



      if (field === "unidadesPorPallet" && palletActual.esDuplicado) {



        const unidadesPrev = parseNumero(palletActual.unidadesPorPallet);



        const unidadesNuevas = parseNumero(value);



        const diff = unidadesNuevas - unidadesPrev; // cuánto creció/disminuyó







        // Buscamos el pallet original hacia arriba (el que tiene duplicarPallet === true)



        let originalIndex = -1;



        for (let i = index - 1; i >= 0; i--) {



          if (palletsCopy[i].duplicarPallet === true) {



            originalIndex = i;



            break;



          }



        }







        if (originalIndex !== -1) {



          const original = palletsCopy[originalIndex];



          const unidadesOriginalPrev = parseNumero(original.unidadesPorPallet);



          let unidadesOriginalNueva = unidadesOriginalPrev - diff;







          if (unidadesOriginalNueva < 0) {



            unidadesOriginalNueva = 0; // evitar negativos



          }







          palletsCopy[originalIndex] = {



            ...original,



            unidadesPorPallet: String(unidadesOriginalNueva),



          };



        }







        // Actualizo el duplicado



        palletsCopy[index] = {



          ...palletActual,



          [field]: nextValue,

          ...(field === "codigo"
            ? {
                detalleProducto: resolveDetalleProductoByCodigoChange({
                  cliente: clienteSel,
                  prevCodigo: palletActual.codigo,
                  prevDetalleProducto: palletActual.detalleProducto,
                  nextCodigo: nextValue,
                }),
              }
            : {}),


        };







        return palletsCopy;



      }







      // ðŸ”¹ Caso normal para cualquier otro campo



      palletsCopy[index] = {



        ...palletActual,



        [field]: nextValue,

        ...(field === "codigo"
          ? {
              detalleProducto: resolveDetalleProductoByCodigoChange({
                cliente: clienteSel,
                prevCodigo: palletActual.codigo,
                prevDetalleProducto: palletActual.detalleProducto,
                nextCodigo: nextValue,
              }),
            }
          : {}),


      };



      return palletsCopy;



    });



  };







  const abrirDuplicarModal = (index) => {



    setDupModalIndex(index);



    setDupModalOpen(true);



  };







  const cerrarDuplicarModal = () => {



    setDupModalOpen(false);



    setDupModalIndex(null);



  };







  const confirmarDuplicado = (cuentaPosicionDuplicado) => {



    if (dupModalIndex === null) {



      cerrarDuplicarModal();



      return;



    }







    const index = dupModalIndex;

    const snapshotAntes = clonePalletSnapshot(pallets);

    const palletOriginal = snapshotAntes[index];

    if (!palletOriginal || palletOriginal.duplicarPallet) {
      cerrarDuplicarModal();
      return;
    }







    setPallets((prev) => {



      const palletsCopy = [...prev];



      const original = palletsCopy[index];







      if (!original || original.duplicarPallet) return prev;







      // Marco el original como "es original de duplicado"



      palletsCopy[index] = {



        ...original,



        duplicarPallet: true,



        esDuplicado: false,



      };







      // Creo el duplicado



      const palletDuplicado = {



        ...original,



        duplicarPallet: false,



        esDuplicado: true,



        palletOriginal: original.nroPallet,



        cuentaPosicion: cuentaPosicionDuplicado,



        unidadesPorPallet: "0",



      };







      // Inserto el duplicado debajo



      palletsCopy.splice(index + 1, 0, palletDuplicado);







      return palletsCopy;



    });







    pushUndoHistory(
      `Se duplico pallet ${palletOriginal.nroPallet || index + 1}`,
      snapshotAntes
    );

    cerrarDuplicarModal();



  };







  // Maneja cambios de checkbox en la tabla



  const handlePalletCheckbox = (index, field) => {



    // ðŸ”¹ Caso especial: Duplicar pallet



    if (field === "duplicarPallet") {



      const palletActual = pallets[index];



      const nuevoValor = !palletActual.duplicarPallet;







      // Solo cuando pasa de false -> true



      if (nuevoValor) {



        abrirDuplicarModal(index);



        return;



      }



    }







    // ðŸ”¹ Resto de checkboxes



    setPallets((prev) =>



      prev.map((p, i) =>



        i === index



          ? {



              ...p,



              [field]: !p[field],



            }



          : p



      )



    );



  };







  // Eliminar una fila de pallets de la grilla



  const handleEliminarPallet = (indexABorrar) => {
    const snapshotAntes = clonePalletSnapshot(pallets);
    const palletABorrar = snapshotAntes[indexABorrar];

    if (!palletABorrar) return;

    pushUndoHistory(
      `Se elimino pallet ${palletABorrar.nroPallet || indexABorrar + 1}`,
      snapshotAntes
    );



    setPallets((prev) => prev.filter((_, index) => index !== indexABorrar));



  };







  // Eliminar un lote de la grilla



  const handleEliminarLote = (loteResumen) => {
    const loteObjetivo = loteResumen || "SIN LOTE";
    const snapshotAntes = clonePalletSnapshot(pallets);
    const palletsAfectados = snapshotAntes.filter((p) => {
      const key = p.lote || "SIN LOTE";
      return key === loteObjetivo;
    });

    if (palletsAfectados.length === 0) return;

    pushUndoHistory(
      `Se elimino lote ${loteObjetivo} (${palletsAfectados.length})`,
      snapshotAntes
    );



    setPallets((prev) =>



      prev.filter((p) => {



        const key = p.lote || "SIN LOTE";



        return key !== loteObjetivo;



      })



    );



  };







  const getPalletCellMeta = (target) => {
    if (!(target instanceof Element)) return null;
    const tbody = tableScrollRef.current?.querySelector("tbody");
    if (!tbody) return null;

    const row = target.closest("tr");
    const cell = target.closest("td");
    if (!row || !cell || !tbody.contains(row)) return null;

    const rowIndex = Array.from(tbody.children).indexOf(row);
    const cellIndex = Array.from(row.children).indexOf(cell);
    const column = PALLET_COLUMNS[cellIndex];
    if (rowIndex < 0 || cellIndex < 0 || !column?.fieldKey) return null;

    return { tbody, rowIndex, cellIndex, column };
  };


  const focusPalletColumnCell = (rowIndex, fieldKey) => {
    if (rowIndex < 0 || !fieldKey) return false;

    const tbody = tableScrollRef.current?.querySelector("tbody");
    const columnIndex = PALLET_COLUMNS.findIndex(
      (column) => column.fieldKey === fieldKey
    );
    if (!tbody || columnIndex < 0) return false;

    const nextRow = tbody.children[rowIndex];
    const nextCell = nextRow?.children[columnIndex];
    const nextControl = nextCell?.querySelector(PALLET_CELL_FOCUSABLE_SELECTOR);
    if (!nextControl) return false;

    nextControl.focus();
    if (
      nextControl instanceof HTMLInputElement &&
      nextControl.type !== "checkbox" &&
      nextControl.type !== "radio"
    ) {
      nextControl.select();
    }
    nextControl.scrollIntoView({ block: "nearest", inline: "nearest" });
    return true;
  };


  const handleSelectPalletColumn = (fieldKey) => {
    if (!fieldKey) return;
    setSelectedPalletColumn(fieldKey);

    const activeMeta = getPalletCellMeta(document.activeElement);
    const targetRowIndex = activeMeta?.rowIndex ?? 0;
    if (!focusPalletColumnCell(targetRowIndex, fieldKey)) {
      focusPalletColumnCell(0, fieldKey);
    }
  };


  const handlePalletHeaderKeyDown = (e, fieldKey) => {
    if (
      !fieldKey ||
      (e.key !== "Enter" && e.key !== " ") ||
      e.shiftKey ||
      e.altKey ||
      e.ctrlKey ||
      e.metaKey
    ) {
      return;
    }

    e.preventDefault();
    handleSelectPalletColumn(fieldKey);
  };


  const handlePalletBodyFocus = (e) => {
    const meta = getPalletCellMeta(e.target);
    if (!meta) return;
    setSelectedPalletColumn(meta.column.fieldKey);
  };


  const handlePalletBodyKeyDown = (e) => {
    if (
      e.key !== "Enter" ||
      e.shiftKey ||
      e.altKey ||
      e.ctrlKey ||
      e.metaKey
    ) {
      return;
    }

    const meta = getPalletCellMeta(e.target);
    if (!meta) return;

    if (!meta.tbody.children[meta.rowIndex + 1]) return;

    e.preventDefault();
    setSelectedPalletColumn(meta.column.fieldKey);
    focusPalletColumnCell(meta.rowIndex + 1, meta.column.fieldKey);
  };







  // Resumen por lote para el modal



  const getResumenPorLote = () => {



    const resumen = {};







    pallets.forEach((p) => {



      const key = p.lote || "SIN LOTE";



      if (!resumen[key]) {


        resumen[key] = {


          lote: key,


          cantidadPallets: 0,


          totalUnidades: 0,


        };


      }


      if (p.cuentaPosicion !== false) {


        resumen[key].cantidadPallets += 1;


      }


      const unidades = parseFloat(p.unidadesPorPallet) || 0;


      resumen[key].totalUnidades += unidades;


    });






    return Object.values(resumen);



  };







  const totalPallets = pallets.length;


  const totalPalletsContables = pallets.reduce(


    (acc, p) => acc + (p.cuentaPosicion !== false ? 1 : 0),


    0


  );


  const totalUnidades = pallets.reduce(


    (acc, p) => acc + (parseFloat(p.unidadesPorPallet) || 0),


    0


  );






  const setFeedback = (text, tone = "info") => {



    setMensaje({ text, tone, ts: Date.now() });



    setTimeout(() => setMensaje(null), 4000);



  };







  const payloadPallets = useMemo(


    () =>


      pallets.map((p) => ({


        ...p,


        fecha: toIsoFecha(p.fecha),


        fechaElaboracion: toIsoFecha(p.fechaElaboracion),


        fechaVencimiento: toIsoFecha(p.fechaVencimiento),


        cantPorFc: toNumber(p.cantPorFc),


        unidadesPorPallet: toNumber(p.unidadesPorPallet),


      })),


    [pallets]


  );






  const getSaveValidationError = () => {
    if (!clienteSel?._id) {
      return "El cliente escrito no es valido. Seleccione un cliente de la lista.";
    }
    if (!String(form.nroRemito || "").trim()) {
      return "Falta Nro. de remito.";
    }
    if (pallets.length === 0) {
      return "Agregue al menos un pallet.";
    }
    return "";
  };

  const abrirModalResumen = () => {
    const validationError = getSaveValidationError();
    if (validationError) {
      setFeedback(validationError, "warn");
      return;
    }

    setModalError("");
    setMostrarModal(true);
  };

  // llamar a la api para crear el ingreso



  const handleCompletarIngreso = async () => {



    const validationError = getSaveValidationError();
    if (validationError) {
      setModalError(validationError);
      setFeedback(validationError, "warn");
      return;
    }







    const payload = {


      clienteId: clienteSel._id,


      fechaIngreso: toIsoFecha(form.fecha),


      ubicacion: form.ubicacion,


      planta: form.planta,



      unidadNegocio: form.unidadNegocio,



      nroRemito: form.nroRemito,



      ingresoPesa: form.ingresoPesa,



      observacionesIngreso: form.observacionesIngreso,
      deposito: depositoActual,



      pallets: payloadPallets,



    };







    try {



      setGuardando(true);
      setModalError("");



      await api.post("/api/ingresos", payload);


      setFeedback("Ingreso guardado", "ok");


      localStorage.removeItem(storageKey);


      setUndoHistory([]);


      setUndoModalOpen(false);


      setTieneCambios(false);


      setMostrarModal(false);


    } catch (error) {


      console.error("Error guardando ingreso:", error);



      const msg =



        error.response?.data?.error ||



        error.response?.data?.msg ||



        "No pude guardar el ingreso";



      setModalError(msg);
      setFeedback(msg, "error");



    } finally {



      setGuardando(false);



    }



  };







  const cerrarModal = () => {



    setMostrarModal(false);
    setModalError("");



  };







  const fetchClientes = async (q) => {
    setBuscandoCliente(true);



    try {



      const query = String(q || "").trim();
      const { data } = query
        ? await api.get("/api/clientes/buscar", { params: { q: query } })
        : await api.get("/api/clientes/listar");



      setClientes(Array.isArray(data) ? data : []);



    } catch (err) {



      console.error("GET /api/clientes/buscar", err.response || err);



    } finally {



      setBuscandoCliente(false);



    }



  };







  useEffect(() => {


    if (clienteSel || !clienteListOpen) {
      setBuscandoCliente(false);
      return;
    }

    const query = clienteQuery.trim();
    setBuscandoCliente(true);


    const t = setTimeout(() => {


      fetchClientes(query);


    }, query ? 250 : 0);


    return () => clearTimeout(t);


  }, [clienteQuery, clienteSel, clienteListOpen]);





  useEffect(() => {
    let active = true;

    api
      .get("/api/ocupacion", {
        params: { deposito: depositoActual, _ts: Date.now() },
      })
      .then(({ data }) => {
        if (!active) return;
        const list = Array.isArray(data) ? data : data?.data || [];
        setOcupacionesConfig(
          (Array.isArray(list) ? list : []).filter(Boolean)
        );
      })
      .catch((error) => {
        if (!active) return;
        console.error("GET /api/ocupacion", error?.response || error);
        setOcupacionesConfig([]);
      });

    return () => {
      active = false;
    };
  }, [depositoActual]);





  useEffect(() => {


    if (!clientes.length) {


      setClienteIndex(-1);


      return;


    }


    setClienteIndex((prev) =>


      prev >= 0 && prev < clientes.length ? prev : 0


    );


  }, [clientes]);






  // Opciones para los selects basadas en los valores guardados.

  const ubicacionesConfiguradas = useMemo(
    () =>
      (ocupacionesConfig || [])
        .filter(
          (item) => item && item.visible !== false && String(item.nombre || "").trim()
        )
        .map((item) => String(item.nombre || "").trim()),
    [ocupacionesConfig]
  );

  const ubicaciones = mergeDistinctStrings(
    ubicacionesConfiguradas,
    normalizeStringList(clienteSel?.ubicacion),
    form.ubicacion
  );


  const plantas = mergeDistinctStrings(resolveClientePlantas(clienteSel), form.planta);


  const unidadesNegocio = [


    ...new Set(
      mergeDistinctStrings(
        normalizeStringList(clienteSel?.unidadNegocio),
        form.unidadNegocio
      )
    ),


  ];






  /*



  const handleCompletarFormulario = () => {



    // await axios.get("/api/cliente/completarFormulario", { idCliente });



  };



  */



  return (



    <div className="ingreso-wrap">



      <div className="ingreso-header">


        <div className="ingreso-title">


          <h3 className="heading-with-icon"><FiPackage /> Ingreso</h3>

        </div>

        <div className="ingreso-header-actions">

          <button


            type="button"


            className="btn btn-recuperar"


            title={
              undoHistory.length > 0
                ? `Ultimo paso: ${undoHistory[0].label}`
                : "No hay pasos para recuperar"
            }


            disabled={undoHistory.length === 0}


            onClick={() => setUndoModalOpen(true)}


          >


            <FiRotateCcw />


            Recuperar pasos


            {undoHistory.length > 0 && (


              <span className="btn-recuperar__count">{undoHistory.length}</span>


            )}


          </button>


          <button


            type="button"


            className="btn btn-limpiar"


            onClick={handleLimpiarFormulario}


          >


            Limpiar formulario


          </button>


        </div>


      </div>






      {mensaje && (



        <div className={`estado-msg ${mensaje.tone || ""}`}>



          {mensaje.text}



        </div>



      )}







      {/* FORMULARIO PRINCIPAL */}



      <form
        onSubmit={handleAgregarPallets}
        onKeyDown={handleFormEnterNavigation}
        className="ingreso-form ingreso-form--compact"
      >



        <div className="card mb-3">



          <div className="card-body">



            <div className="row mb-1">
              <div className="ingreso-cliente-edit-action">
                <button
                  type="button"
                  className="btn ingreso-editar-cliente"
                  disabled={!clienteSel?._id}
                  onClick={() => {
                    if (!clienteSel?._id) return;
                    setClienteListOpen(false);
                    setCodigoListOpen(false);
                    setClienteEditar(clienteSel);
                  }}
                  title={clienteSel?._id ? `Editar ${clienteSel.nombreCliente}` : "Seleccione un cliente para editarlo"}
                >
                  <FiEdit2 /> Editar cliente
                </button>
              </div>



              <div className="col-md-4">



                <label className="form-label">Cliente</label>



                <div className="cliente-autocomplete">



                  <input


                    type="text"


                    className="form-control form-control-sm"


                    placeholder="Escriba el nombre del cliente"


                    value={clienteQuery}


                    onChange={(e) => {


                      setClienteQuery(e.target.value);


                      setClienteSel(null);


                      setClienteIndex(-1);

                      setClienteListOpen(true);


                    }}


                    onKeyDown={handleClienteKeyDown}


                    onBlur={handleClienteBlur}


                    onFocus={handleClienteFocus}


                  />


                  {buscandoCliente && (



                    <div className="cliente-estado">Buscando...</div>



                  )}

                  {!buscandoCliente &&
                    !clienteSel &&
                    clienteListOpen &&
                    clientes.length === 0 && (
                      <div className="cliente-estado">
                        {clienteQuery.trim()
                          ? "No se encontraron clientes con ese nombre"
                          : "No hay clientes cargados"}
                      </div>
                    )}



                  {clienteListOpen && !clienteSel && clientes.length > 0 && (



                    <div className="cliente-list">



                      {clientes.map((c, idx) => (


                        <div


                          key={c._id}


                          className={`cliente-item${


                            idx === clienteIndex ? " active" : ""


                          }`}


                          onMouseEnter={() => setClienteIndex(idx)}


                          onMouseDown={(e) => {


                            e.preventDefault();


                            handleSelectCliente(c);


                          }}


                        >


                          <strong>{c.nombreCliente}</strong>{" "}



                          <span className="cliente-sub">



                            {c.codCliente} | CUIT {c.CUIT}



                          </span>



                        </div>



                      ))}



                    </div>



                  )}



                </div>



              </div>



              <div className="col-md-2">



                <label className="form-label">Fecha ingreso</label>


                <input


                  type="text"


                  inputMode="numeric"


                  className="form-control form-control-sm"


                  name="fecha"


                  placeholder="DD/MM/AAAA"


                  maxLength={10}


                  value={form.fecha}


                  onChange={handleFormChange}


                />


              </div>



              <div className="col-md-2">



                <label className="form-label">{"Ubicaci\u00f3n"}</label>



                <select



                  className="form-select form-select-sm"



                  name="ubicacion"



                  value={form.ubicacion}



                  onChange={handleFormChange}



                >



                  <option value="">Seleccionar...</option>



                  {ubicaciones.map((u) => (



                    <option key={u} value={u}>



                      {u}



                    </option>



                  ))}



                  {form.ubicacion && !ubicaciones.includes(form.ubicacion) && (



                    <option value={form.ubicacion}>{form.ubicacion}</option>



                  )}



                </select>

              </div>



              <div className="col-md-2">



                <label className="form-label">Procedencia / Planta</label>



                <select



                  className="form-select form-select-sm"



                  name="planta"



                  value={form.planta}



                  onChange={handleFormChange}



                >



                  <option value="">Seleccionar...</option>



                  {plantas.map((p) => (



                    <option key={p} value={p}>



                      {p}



                    </option>



                  ))}



                  {form.planta && !plantas.includes(form.planta) && (



                    <option value={form.planta}>{form.planta}</option>



                  )}



                </select>



              </div>



              <div className="col-md-2">



                <label className="form-label">Unidad de negocio</label>



                <select



                  className="form-select form-select-sm"



                  name="unidadNegocio"



                  value={form.unidadNegocio}



                  onChange={handleFormChange}



                >



                  <option value="">Seleccionar...</option>



                  {unidadesNegocio.map((u) => (



                    <option key={u} value={u}>



                      {u}



                    </option>



                  ))}



                  {form.unidadNegocio &&



                    !unidadesNegocio.includes(form.unidadNegocio) && (



                      <option value={form.unidadNegocio}>



                        {form.unidadNegocio}



                      </option>



                    )}



                </select>



              </div>



            </div>







            <div className="row mb-1">



              <div className="col-md-3">



                <label className="form-label">Nro. remito</label>



                <input



                  type="text"



                  className="form-control form-control-sm"



                  name="nroRemito"



                  value={form.nroRemito}



                  onChange={handleFormChange}



                />



              </div>



              <div className="col-md-3">



                <label className="form-label">FC / Grupo / Proveedor</label>



                <input



                  type="text"



                  className="form-control form-control-sm"



                  name="fcGrupoProveedor"



                  value={form.fcGrupoProveedor}



                  onChange={handleFormChange}



                />



              </div>



              <div className="col-md-3">



                <label className="form-label">{"C\u00f3digo"}</label>


                <div className="codigo-autocomplete">
                  <input
                    ref={codigoInputRef}
                    type="text"
                    className="form-control form-control-sm"
                    name="codigo"
                    value={form.codigo}
                    placeholder={
                      clienteSel ? "Seleccione o escriba un codigo" : "Seleccione un cliente"
                    }
                    autoComplete="off"
                    onChange={(e) => {
                      handleFormChange(e);
                      setCodigoListOpen(Boolean(clienteSel));
                      setCodigoIndex(-1);
                    }}
                    onFocus={handleCodigoFocus}
                    onBlur={handleCodigoBlur}
                    onKeyDown={handleCodigoFieldKeyDown}
                  />

                  {codigoListOpen && clienteSel && (
                    <div className="codigo-list">
                      {codigosProductoFiltrados.length > 0 ? (
                        codigosProductoFiltrados.map((item, idx) => (
                          <div
                            key={`${item.codigo}-${idx}`}
                            className={`codigo-item${idx === codigoIndex ? " active" : ""}`}
                            onMouseEnter={() => setCodigoIndex(idx)}
                            onMouseDown={(e) => {
                              e.preventDefault();
                              handleSelectCodigoProducto(item);
                            }}
                          >
                            <strong>{item.codigo}</strong>
                            <span className="codigo-sub">{item.detalleProducto}</span>
                          </div>
                        ))
                      ) : (
                        <div className="codigo-estado">
                          {clienteCodigosProducto.length
                            ? "No hay codigos que coincidan"
                            : "Este cliente todavia no tiene codigos guardados"}
                        </div>
                      )}
                    </div>
                  )}
                </div>



              </div>



              <div className="col-md-3">



                <label className="form-label">



                  Detalle del producto



                </label>



                <input



                  type="text"



                  className="form-control form-control-sm"



                  placeholder="Detalle de producto"



                  name="detalleProducto"

                  ref={detalleProductoInputRef}



                  value={form.detalleProducto}



                  onChange={handleFormChange}



                />

                {form.codigo && clienteSel?.nombreCliente && codigoClienteMatch && (
                  <small className="text-muted d-block mt-1">
                    Detalle tomado desde los codigos del cliente.
                  </small>
                )}

                {/* <input



                  type="text"



                  className="form-control"



                  placeholder="Nro. FC"



                  name="nroFc"



                  value={form.nroFc}



                  onChange={handleFormChange}



                /> */}



              </div>



            </div>







            <div className="row mb-1">



              <div className="col-md-2">



                <label className="form-label">Cant. x FC</label>



                <input



                  type="text"



                  className="form-control form-control-sm"



                  name="cantPorFc"



                  value={form.cantPorFc}



                  onChange={handleFormChange}



                />



              </div>



              <div className="col-md-2">



                <label className="form-label">Lote</label>



                <input



                  type="text"



                  className="form-control form-control-sm"



                  name="lote"



                  value={form.lote}



                  onChange={handleFormChange}



                />



              </div>



              <div className="col-md-2">



                <label className="form-label">{"Fecha elaboraci\u00f3n"} <span className="req-star">*</span></label>



                <input


                  type="text"


                  inputMode="numeric"


                  className="form-control form-control-sm input-date-compact"


                  name="fechaElaboracion"


                  placeholder="DD/MM/AAAA"


                  maxLength={10}


                  value={form.fechaElaboracion}


                  onChange={handleFormChange}


                />


              </div>



              <div className="col-md-2">



                <label className="form-label">Fecha vencimiento <span className="req-star">*</span></label>



                <input


                  type="text"


                  inputMode="numeric"


                  className="form-control form-control-sm input-date-compact"


                  name="fechaVencimiento"


                  placeholder="DD/MM/AAAA"


                  maxLength={10}


                  value={form.fechaVencimiento}


                  onChange={handleFormChange}


                />


              </div>



              <div className="col-md-2">



                <label className="form-label">ID</label>



                <input



                  type="text"



                  className="form-control form-control-sm"



                  name="idInterno"



                  value={form.idInterno}



                  onChange={handleFormChange}



                />



              </div>



              <div className="col-md-2">



                <label className="form-label">Tipo embalaje</label>



                <input


                  type="text"


                  className="form-control form-control-sm"


                  name="tipoEmbalaje"


                  value={form.tipoEmbalaje}


                  onChange={handleFormChange}
                />


              </div>



            </div>







            <div className="row mb-1">



              <div className="col-md-2">



                <label className="form-label">Peso / Medidas</label>



                <input



                  type="text"



                  className="form-control form-control-sm"



                  name="pesoMedidas"



                  value={form.pesoMedidas}



                  onChange={handleFormChange}



                />



              </div>



              <div className="col-md-2">



                <label className="form-label">Nro. pallet (base)</label>



                <input



                  type="text"



                  className="form-control form-control-sm"



                  name="nroPallet"



                  value={form.nroPallet}



                  onChange={handleFormChange}



                />



              </div>



              <div className="col-md-2">



                <label className="form-label">Unidades por pallet</label>



                <input



                  type="number"



                  className="form-control form-control-sm"



                  name="unidadesPorPallet"



                  min={1}



                  value={form.unidadesPorPallet}



                  onChange={handleFormChange}



                />



              </div>



              <div className="col-md-2">



                <label className="form-label">Precinto SENASA</label>



                <input



                  type="text"



                  className="form-control form-control-sm"



                  name="recintoSenasa"



                  value={form.recintoSenasa}



                  onChange={handleFormChange}



                />



              </div>



              <div className="col-md-2">



                <label className="form-label">{"\u00bfEste ingreso pesa?"}</label>



                <select



                  className="form-select form-select-sm"



                  name="ingresoPesa"



                  value={form.ingresoPesa}



                  onChange={handleFormChange}



                >



                  <option value="no">No</option>



                  <option value="si">{"S\u00ed"}</option>



                </select>



              </div>



              <div className="col-md-2">



                <label className="form-label">{"Condici\u00f3n"}</label>



                <select



                  className="form-select form-select-sm"



                  name="condicion"



                  value={form.condicion}



                  onChange={handleFormChange}



                >



                  <option value="OK">OK</option>



                  <option value="ROTAS">Rotas</option>



                </select>



              </div>



            </div>







            <div className="row mb-1">



              <div className="col-md-8">



                <label className="form-label">Observaciones de ingreso</label>



                <input



                  type="text"



                  className="form-control form-control-sm"



                  name="observacionesIngreso"



                  value={form.observacionesIngreso}



                  onChange={handleFormChange}



                />



              </div>



              <div className="col-md-2 d-flex align-items-end">



                <div className="form-check">



                  <input



                    className="form-check-input"



                    type="checkbox"



                    id="mantenerDatos"



                    checked={mantenerDatos}



                    onChange={handleMantenerDatosChange}



                  />



                  <label className="form-check-label" htmlFor="mantenerDatos">



                    Mantener datos



                  </label>



                </div>



              </div>



              <div className="col-md-2">



                <label className="form-label">Replicar ingreso por</label>



                <input



                  type="number"



                  className="form-control form-control-sm"



                  min={1}



                  value={replicarPor ?? ""}



                  onChange={handleReplicarChange}



                />



              </div>



            </div>



          </div>







          <div className="card-footer text-end">



            <button



              type="submit"



              className="btn btn-primary"



            >



              Continuar (agregar pallets)



            </button>



          </div>



        </div>



      </form>







      {/* TABLA DE PALLETS (tipo Excel) */}



      {pallets.length > 0 && (



        <div className="card mb-3">



          <div className="card-header">


            Pallets ingresados ({totalPallets})


          </div>


          <div className="card-body p-0">


            <div


              className="ingreso-table-scrollbar"


              ref={tableTopScrollRef}


              style={{


                display: tableScrollW > tableClientW ? "block" : "none",


              }}


              aria-hidden="true"


            >


              <div style={{ width: tableScrollW, height: 1 }} />


            </div>


            <div className="table-responsive" ref={tableScrollRef}>


              <table className="table table-sm table-striped mb-0 tabla-pallets">

                <colgroup>

                  {palletColWidths.map((width, index) => (

                    <col

                      key={PALLET_COLUMNS[index]?.key || index}

                      style={{ width: `${width}px` }}

                    />

                  ))}

                </colgroup>

                <thead className="table-light">

                  <tr>

                    {PALLET_COLUMNS.map((col, index) => (

                      <th
                        key={col.key}
                        data-col-index={index}
                        className={[
                          col.fieldKey ? "tabla-pallets__th--selectable" : "",
                          selectedPalletColumn === col.fieldKey
                            ? "tabla-pallets__th--selected"
                            : "",
                        ]
                          .filter(Boolean)
                          .join(" ")}
                        onClick={
                          col.fieldKey
                            ? () => handleSelectPalletColumn(col.fieldKey)
                            : undefined
                        }
                        onKeyDown={
                          col.fieldKey
                            ? (e) => handlePalletHeaderKeyDown(e, col.fieldKey)
                            : undefined
                        }
                        tabIndex={col.fieldKey ? 0 : undefined}
                        role={col.fieldKey ? "button" : undefined}
                        aria-pressed={
                          col.fieldKey
                            ? selectedPalletColumn === col.fieldKey
                            : undefined
                        }
                      >

                        {col.label}

                        <span

                          className="col-resize-handle"

                          onClick={(e) => e.stopPropagation()}

                          onMouseDown={startResizeColumn("pallet", index)}

                        />

                      </th>

                    ))}

                  </tr>

                </thead>



                <tbody
                  onFocusCapture={handlePalletBodyFocus}
                  onKeyDown={handlePalletBodyKeyDown}
                >



                  {pallets.map((p, index) => (



                    <tr key={index}>



                      <td>



                        <input


                          type="text"


                          className="form-control form-control-sm"


                          value={p.fcGrupoProveedor}


                          style={autoSizeStyle(p.fcGrupoProveedor)}


                          onChange={(e) =>


                            handlePalletChange(


                              index,


                              "fcGrupoProveedor",


                              e.target.value



                            )



                          }



                        />



                      </td>



                      <td>



                        <input


                          type="text"


                          className="form-control form-control-sm"


                          value={p.codigo}


                          style={autoSizeStyle(p.codigo)}


                          onChange={(e) =>


                            handlePalletChange(index, "codigo", e.target.value)


                          }


                        />


                      </td>



                      <td>



                        <input


                          type="text"


                          className="form-control form-control-sm"


                          placeholder="Detalle"


                          value={p.detalleProducto}


                          style={autoSizeStyle(p.detalleProducto, 10, 40)}


                          onChange={(e) =>


                            handlePalletChange(


                              index,


                              "detalleProducto",


                              e.target.value



                            )



                          }



                        />



                        {/* <input



                          type="text"



                          className="form-control form-control-sm"



                          placeholder="Nro. FC"



                          value={p.nroFc}



                          onChange={(e) =>



                            handlePalletChange(index, "nroFc", e.target.value)



                          }



                        /> */}



                      </td>



                      <td>



                        <input


                          type="text"


                          className="form-control form-control-sm"


                          value={p.cantPorFc}


                          style={autoSizeStyle(p.cantPorFc, 6, 12)}


                          onChange={(e) =>


                            handlePalletChange(


                              index,


                              "cantPorFc",


                              e.target.value



                            )



                          }



                        />



                      </td>



                      <td>



                        <input


                          type="text"


                          className="form-control form-control-sm"


                          value={p.lote}


                          style={autoSizeStyle(p.lote, 6, 14)}


                          onChange={(e) =>


                            handlePalletChange(index, "lote", e.target.value)


                          }


                        />


                      </td>



                      <td>


                        <input


                          type="text"


                          inputMode="numeric"


                          className="form-control form-control-sm"


                          placeholder="DD/MM/AAAA"


                          maxLength={10}


                          value={p.fechaElaboracion}


                          style={autoSizeStyle(p.fechaElaboracion, 10, 14)}


                          onChange={(e) =>


                            handlePalletChange(


                              index,


                              "fechaElaboracion",


                              e.target.value


                            )



                          }



                        />



                      </td>



                      <td>


                        <input


                          type="text"


                          inputMode="numeric"


                          className="form-control form-control-sm"


                          placeholder="DD/MM/AAAA"


                          maxLength={10}


                          value={p.fechaVencimiento}


                          style={autoSizeStyle(p.fechaVencimiento, 10, 14)}


                          onChange={(e) =>


                            handlePalletChange(


                              index,


                              "fechaVencimiento",


                              e.target.value


                            )



                          }



                        />



                      </td>



                      <td>



                        <input


                          type="text"


                          className="form-control form-control-sm"


                          value={p.idInterno}


                          style={autoSizeStyle(p.idInterno, 6, 16)}


                          onChange={(e) =>


                            handlePalletChange(


                              index,


                              "idInterno",


                              e.target.value



                            )



                          }



                        />



                      </td>



                      <td>



                        <input


                          type="text"


                          className="form-control form-control-sm"


                          value={p.tipoEmbalaje}


                          style={autoSizeStyle(p.tipoEmbalaje, 8, 24)}


                          onChange={(e) =>


                            handlePalletChange(


                              index,


                              "tipoEmbalaje",


                              e.target.value



                            )



                          }



                        />



                      </td>



                      <td>



                        <input


                          type="text"


                          className="form-control form-control-sm"


                          value={p.pesoMedidas}


                          style={autoSizeStyle(p.pesoMedidas, 8, 20)}


                          onChange={(e) =>


                            handlePalletChange(


                              index,


                              "pesoMedidas",


                              e.target.value



                            )



                          }



                        />



                      </td>



                      <td>



                        <input


                          type="text"


                          className="form-control form-control-sm"


                          id={`pallet-${index}`}


                          value={p.nroPallet}


                          style={autoSizeStyle(p.nroPallet, 8, 16)}


                          onChange={(e) =>


                            handlePalletChange(


                              index,


                              "nroPallet",


                              e.target.value



                            )



                          }



                        />



                      </td>



                      <td>



                        <input


                          type="number"


                          className="form-control form-control-sm"


                          value={p.unidadesPorPallet}


                          style={autoSizeStyle(p.unidadesPorPallet, 6, 12)}


                          onChange={(e) =>


                            handlePalletChange(


                              index,


                              "unidadesPorPallet",


                              e.target.value



                            )



                          }



                        />



                      </td>



                      <td>



                        <select


                          className="form-select form-select-sm"


                          value={p.condicion}


                          style={autoSizeStyle(p.condicion, 6, 10)}


                          onChange={(e) =>


                            handlePalletChange(


                              index,


                              "condicion",


                              e.target.value



                            )



                          }



                        >



                          <option value="OK">OK</option>



                          <option value="ROTAS">Rotas</option>



                        </select>



                      </td>



                      <td>



                        <input


                          type="text"


                          className="form-control form-control-sm"


                          value={p.motivoDanioIn}


                          style={autoSizeStyle(p.motivoDanioIn, 8, 24)}


                          onChange={(e) =>


                            handlePalletChange(


                              index,


                              "motivoDanioIn",


                              e.target.value



                            )



                          }



                        />



                      </td>







                      <td>



                        <input


                          type="text"


                          className="form-control form-control-sm"


                          value={p.observacionesIngreso}


                          style={autoSizeStyle(p.observacionesIngreso, 12, 40)}


                          onChange={(e) =>


                            handlePalletChange(


                              index,


                              "observacionesIngreso",


                              e.target.value



                            )



                          }



                        />



                      </td>







                      <td>



                        <input


                          type="text"


                          className="form-control form-control-sm"


                          value={p.palletOriginal}


                          style={autoSizeStyle(p.palletOriginal, 8, 18)}


                          onChange={(e) =>


                            handlePalletChange(


                              index,


                              "palletOriginal",


                              e.target.value



                            )



                          }



                        />



                      </td>







                      <td className="text-center">



                        <input



                          type="checkbox"



                          className="form-check-input"



                          checked={p.duplicarPallet}



                          onChange={() =>



                            handlePalletCheckbox(index, "duplicarPallet")



                          }



                        />



                      </td>



                      <td className="text-center">



                        <input



                          type="checkbox"



                          className="form-check-input"



                          checked={p.cuentaPosicion}



                          onChange={() =>



                            handlePalletCheckbox(index, "cuentaPosicion")



                          }



                        />



                      </td>



                      <td className="text-center">



                        <button



                          type="button"



                          className="btn btn-sm btn-delete"



                          title="Eliminar pallet"



                          onClick={() => handleEliminarPallet(index)}



                        >



                          <FiTrash2 />



                        </button>



                      </td>



                    </tr>



                  ))}



                </tbody>



              </table>



            </div>



          </div>







          <div className="card-footer mt-3">



            <div>



              <table className="table table-sm ingreso-resumen-table">
                <colgroup>
                  {resumenColWidths.map((width, index) => (
                    <col
                      key={RESUMEN_COLUMNS[index]?.key || index}
                      style={{ width: `${width}px` }}
                    />
                  ))}
                </colgroup>
                <thead>
                  <tr>
                    {RESUMEN_COLUMNS.map((col, index) => (
                      <th key={col.key} data-col-index={index}>
                        {col.label}
                        <span
                          className="col-resize-handle"
                          onMouseDown={startResizeColumn("resumen", index)}
                        />
                      </th>
                    ))}
                  </tr>
                </thead>



                <tbody>



                  {getResumenPorLote().map((r) => (



                    <tr key={r.lote}>



                      <td>{r.lote}</td>



                      <td>{r.cantidadPallets}</td>



                      <td>{r.totalUnidades}</td>







                      <td className="text-end">



                        <button



                          type="button"



                          className="btn btn-sm btn-delete"



                          title="Eliminar lote"



                          onClick={() => handleEliminarLote(r.lote)}



                        >



                          <FiTrash2 />



                        </button>



                      </td>



                    </tr>



                  ))}



                </tbody>



              </table>



              <hr />



              <p>


                <strong>Total pallets:</strong> {totalPalletsContables}


              </p>


              <p>



                <strong>Total unidades:</strong> {totalUnidades}



              </p>



            </div>



            <div className="text-end">



              <button



                type="button"



                className="btn btn-success"



                disabled={guardando}



                onClick={abrirModalResumen}



              >



                Finalizar



              </button>



            </div>



          </div>



        </div>



      )}







      {/* MODAL DE RECUPERACION */}

      {undoModalOpen && (

        <div className="ingreso-modal-overlay">

          <div className="modal-dialog ingreso-modal ingreso-modal--history">

            <div className="modal-content">

              <div className="modal-header">

                <div>

                  <h5 className="modal-title">Recuperar pasos</h5>

                  <div className="undo-history-subtitle">
                    Reverti duplicados o eliminaciones de pallets.
                  </div>

                </div>

                <button

                  type="button"

                  className="btn-close"

                  onClick={() => setUndoModalOpen(false)}

                ></button>

              </div>

              <div className="modal-body">

                {undoHistory.length === 0 ? (

                  <p>No hay pasos disponibles para recuperar.</p>

                ) : (

                  <>

                    <p className="undo-history-note">
                      Al volver a un paso tambien se revierten los movimientos posteriores.
                    </p>

                    <div className="undo-history-list">

                      {undoHistory.map((step) => (

                        <div key={step.id} className="undo-history-item">

                          <div className="undo-history-item__content">

                            <div className="undo-history-item__title">{step.label}</div>

                            <div className="undo-history-item__meta">
                              {formatUndoTimestamp(step.createdAt)}
                            </div>

                          </div>

                          <button

                            type="button"

                            className="btn btn-primary btn-sm"

                            onClick={() => handleRecuperarPaso(step.id)}

                          >

                            Volver a este punto

                          </button>

                        </div>

                      ))}

                    </div>

                  </>

                )}

              </div>

              <div className="modal-footer">

                <button

                  type="button"

                  className="btn btn-primary"

                  disabled={undoHistory.length === 0}

                  onClick={handleDeshacerUltimoPaso}

                >

                  Deshacer ultimo paso

                </button>

                <button

                  type="button"

                  className="btn btn-outline-light"

                  onClick={() => setUndoModalOpen(false)}

                >

                  Cerrar

                </button>

              </div>

            </div>

          </div>

        </div>

      )}



      {/* MODAL DE DUPLICAR PALLET */}



      {dupModalOpen && (



        <div className="ingreso-modal-overlay">



          <div className="modal-dialog ingreso-modal ingreso-modal--confirm">



            <div className="modal-content">



              <div className="modal-header">



                <h5 className="modal-title">Duplicar pallet</h5>



                <button



                  type="button"



                  className="btn-close"



                  onClick={cerrarDuplicarModal}



                ></button>



              </div>



              <div className="modal-body">



                <p>{"\u00bfEl pallet duplicado cuenta posici\u00f3n?"}</p>



              </div>



              <div className="modal-footer">



                <button



                  type="button"



                  className="btn btn-primary"



                  onClick={() => confirmarDuplicado(true)}



                >



                  Si



                </button>



                <button



                  type="button"



                  className="btn btn-secondary"



                  onClick={() => confirmarDuplicado(false)}



                >



                  No



                </button>



                <button



                  type="button"



                  className="btn btn-outline-light"



                  onClick={cerrarDuplicarModal}



                >



                  Cancelar



                </button>



              </div>



            </div>



          </div>



        </div>



      )}







      {clienteEditar && (
        <GestorClientes
          key={clienteEditar._id}
          clienteEditar={clienteEditar}
          onClose={() => setClienteEditar(null)}
          onSaved={handleClienteEditado}
        />
      )}

      {codigoRapidoOpen && (

        <div className="ingreso-modal-overlay" onClick={closeCodigoRapidoModal}>

          <div className="modal-dialog ingreso-modal ingreso-modal--confirm" onClick={(e) => e.stopPropagation()}>

            <div className="modal-content" onKeyDown={handleCodigoRapidoModalKeyDown}>

              <div className="modal-header">

                <h5 className="modal-title">Agregar codigo</h5>

                <button

                  type="button"

                  className="btn-close"

                  onClick={closeCodigoRapidoModal}

                ></button>

              </div>

              <div className="modal-body">

                <p className="text-muted mb-3">
                  Guarda el codigo y el detalle para recuperarlos automaticamente en Ingreso.
                </p>

                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label">Codigo</label>
                    <input
                      ref={codigoRapidoCodigoInputRef}
                      type="text"
                      className="form-control form-control-sm"
                      value={codigoRapidoForm.codigo}
                      onChange={(e) => {
                        setCodigoRapidoForm((prev) => ({ ...prev, codigo: e.target.value }));
                        if (codigoRapidoError) setCodigoRapidoError("");
                      }}
                      placeholder="Ej: ABC123"
                    />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Detalle de producto</label>
                    <input
                      ref={codigoRapidoDetalleInputRef}
                      type="text"
                      className="form-control form-control-sm"
                      value={codigoRapidoForm.detalleProducto}
                      onChange={(e) => {
                        setCodigoRapidoForm((prev) => ({
                          ...prev,
                          detalleProducto: e.target.value,
                        }));
                        if (codigoRapidoError) setCodigoRapidoError("");
                      }}
                      placeholder="Detalle de producto"
                    />
                  </div>
                </div>

                {codigoRapidoError ? (
                  <div className="alert alert-danger mt-3 mb-0 py-2" role="alert">
                    {codigoRapidoError}
                  </div>
                ) : null}

              </div>

              <div className="modal-footer">

                <button

                  type="button"

                  className="btn btn-secondary"

                  onClick={closeCodigoRapidoModal}

                >

                  Cancelar

                </button>

                <button

                  type="button"

                  className="btn btn-primary"

                  disabled={codigoRapidoSaving}

                  onClick={saveCodigoRapido}

                >

                  {codigoRapidoSaving ? "Guardando..." : "Guardar codigo"}

                </button>

              </div>

            </div>

          </div>

        </div>

      )}

      {/* MODAL DE RESUMEN */}



      {mostrarModal && (



        <div className="ingreso-modal-overlay">



          <div className="modal-dialog modal-lg ingreso-modal">



            <div className="modal-content">



              <div className="modal-header">



                <h5 className="modal-title">Resumen por lote</h5>



                <button



                  type="button"



                  className="btn-close"



                  onClick={cerrarModal}



                ></button>



              </div>



              <div className="modal-body">

                {modalError && (
                  <div className="estado-msg error" role="alert">
                    {modalError}
                  </div>
                )}



                {pallets.length === 0 ? (



                  <p>No hay pallets para mostrar.</p>



                ) : (



                  <>



                    <table className="table table-sm">



                      <thead>



                        <tr>



                          <th>Lote</th>



                          <th>Cantidad pallets</th>



                          <th>Total unidades</th>



                        </tr>



                      </thead>



                      <tbody>



                        {getResumenPorLote().map((r) => (



                          <tr key={r.lote}>



                            <td>{r.lote}</td>



                            <td>{r.cantidadPallets}</td>



                            <td>{r.totalUnidades}</td>



                          </tr>



                        ))}



                      </tbody>



                    </table>



                    <hr />



                    <p>


                      <strong>Total pallets:</strong> {totalPalletsContables}


                    </p>


                    <p>



                      <strong>Total unidades:</strong> {totalUnidades}



                    </p>



                  </>



                )}



              </div>



              <div className="modal-footer">



                <button



                  type="button"



                  className="btn btn-secondary"



                  onClick={cerrarModal}



                >



                  Cerrar



                </button>



                <button



                  className="btn btn-primary"



                  disabled={guardando}



                  onClick={handleCompletarIngreso}



                >



                  {guardando ? "Guardando..." : "Confirmar y guardar"}



                </button>



              </div>



            </div>



          </div>



        </div>



      )}



    </div>



  );



};







export default Ingreso;







